import { FieldName, FieldsConfig } from './types';

export const getFieldDisabledConfig = (fieldName: FieldName, fieldsConfig?: FieldsConfig) =>
    !!fieldsConfig?.disabledFields?.includes(fieldName);
export const getFieldLockedConfig = (fieldName: FieldName, fieldsConfig?: FieldsConfig) =>
    !!fieldsConfig?.lockedFields?.includes(fieldName);
